import { Observable } from 'rxjs'

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? decodeURIComponent(match[2]) : undefined
}

function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
}

function getFbclidFromFbcCookie(fbc: string): string | undefined {
  const parts = fbc.split('.')
  return parts.length > 0 ? parts[parts.length - 1] : undefined
}

export const fbcFromUrl$ = new Observable<string | undefined>((subscriber) => {
  if (typeof window === 'undefined') {
    subscriber.next(undefined)
    subscriber.complete()
    return
  }
  const params = new URLSearchParams(window.location.search)
  const fbclid = params.get('fbclid')
  const fbcCookie = getCookie('_fbc')
  const fbcCookieFbclid = fbcCookie ? getFbclidFromFbcCookie(fbcCookie) : undefined

  if (fbclid) {
    if (!fbcCookie || fbclid !== fbcCookieFbclid) {
      const subdomainIndex = window.location.hostname.split('.').length - 1
      const creationTime = Date.now()
      const formattedFbc = `fb.${subdomainIndex}.${creationTime}.${fbclid}`
      setCookie('_fbc', formattedFbc, 90)
      subscriber.next(formattedFbc)
      subscriber.complete()
      return
    }
    subscriber.next(fbcCookie)
    subscriber.complete()
    return
  }

  subscriber.next(fbcCookie)
  subscriber.complete()
})
